import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import {cleanUpObject, convertToSortedArray} from '../../app/functions';
import {AnalyticsLogger, CrashLogger} from '../../app/logger';

/* Actions */
import * as Actions from '../../redux/actions';


const parseJson = (json) => {
    try {
        return json ? JSON.parse(json) : {}
    } catch (e) {
    }
    return {}
}

class GeneralDeclarationRequest extends baseRequest {
    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name = 'General Declaration Request';
        this.Config = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;

        if (window.GeneralDeclaration) {
            this.response = {data: window.GeneralDeclaration};
            this.onSuccess();
        } else {
            this.call(this.Config.api.requests.generalDeclaration);
            // this.call(this.Config.api.requests.generalDeclaration, undefined, 'get');
        }
    }

    // Parse successful response
    onSuccess() {
        let {data} = this.response;

        AnalyticsLogger.setUrl(data?.['analytics_logger_url']);
        CrashLogger.setUrl(data?.['crash_logger_url']);

        if ('media_server' in data) {
            this.Config.api.mediaUrl = data.media_server;
        }
        let responseData = {};


        responseData.MainMenu = convertToSortedArray(data.main_menu);
        responseData.PolicyPageId = data.policy_page_url;
        responseData.PrivacyPage = data.privacy_policy_url;
        responseData.Translations = data.translationsArr;
        responseData.IconTypes = cleanUpObject(data.benefitTypes);
        responseData.app_store_link = data.global_app_link;
        responseData.citiesArr = data.siteRelevantCities;
        responseData.ContentUrl = this.parseContentTable(data.contentUrls);
        responseData.CategoriesArr = this.parseCategories(data.categories);
        responseData.BenefitTypes = data.benefitTypes;
        responseData.contentWorlds = data.contentWorlds;
        responseData.FooterLinks = {};
        responseData.FooterLinks.links = data.footer;
        responseData.FooterLinks.social_media_links = data.social_media_links;
        responseData.FooterLinks.app_store_links = data.app_store_links;
        responseData.DefaultGeo = data.location_search_params;
        responseData.PopTrans = data.popups;
        responseData.bannerInterval = data.home_page_banners_interval;
        responseData.work_places = data.workPlaces;
        /////banner for search discount on debit
        responseData.discount_debit_banner = data.discount_debit_banner;
        responseData.search_is_network = data.search_is_network;
        responseData.hotSearches = data.hot_searches;
        responseData.bannersArr = data.bannersArr;
        responseData.closedBenefitTypes = data.benefitTypesForLoggedUsers;
        responseData.verificationCodeMaxAttemptsError = data.verification_code_max_attempts_error;
        responseData.subCategoriesMenu = data.sub_categories_menu;
        responseData.mainCategoriesMenu = data.main_categories_menu;
        responseData.orderStatusArr = data.orderStatusArr;
        responseData.itemsSortTypes = data.itemsSortTypes;
        responseData.taxPercent = data.taxPercent;
        responseData.tradeBenefitsChargeTypes = data.tradeBenefitsChargeTypes;
        responseData.benefitTypesWhatRequireUserValidation = data.benefitTypesRequiringUserValidation;
        responseData.home_page_banners_interval = data.home_page_banners_interval;
        responseData.home_page_slider_types = data.home_page_slider_types;
        responseData.tradeBenefitType = data.tradeBenefitType;
        responseData.tutorial_display_number = data.tutorial_display_number
        responseData.vehicle_ad_display_types = data.vehicle_ad_display_types;
        responseData.mega_menu_max_categories = data.mega_menu_max_categories;
        responseData.mega_menu_max_subcategories = data.mega_menu_max_subcategories;
        responseData.strip_navigator_offset_top = data.strip_navigator_offset_top;
        responseData.couponsCancellationReasons = data.couponsCancellationReasons;
        responseData.magazines = data.magazines;
        responseData.mega_menu = data.mega_menu;
        responseData.insurance_data = {link: data.insurance_website_link_address};
        responseData.dataSharingConfig = data.dataSharingConfig;
        responseData.newsletterPopup = data.newsletterPopup;
        responseData.homepageLogos = {
            website_logo: data.websiteLogo,
            mobile_logo: data.mobileLogo,
        };
        responseData.parameters = {
            appHomeScreenDynamicLink: data.app_home_screen_dynamic_link,
            appPopupDebounceDays: data.app_popup_debounce_days,
            numOfSecondsTillNewsletterPopupClose: data.NUM_OF_SECONDS_TILL_NEWSLETTER_POPUP_CLOSE,
            numOfMinutesTillNextNewsletterShow: data.NUM_OF_MINUTES_TILL_NEWSLETTER_SHOW_AGAIN,
            sms_verification_send_code_again__visible_in_sec: data.sms_verification_send_code_again__visible_in_sec,
            botConfiguration: {
                mainConfiguration: data.bot_configuration,
                abTestingPercentage: data.bot_ab_testing_percentage,
            },
            enableAppPopup: data.enable_app_link_popup,
            forumConfiguration: {
                promotionalBanner: data.forum_configuration_promotional_banner,
                welcomeMessageHtml: data.forum_configuration_welcome_message_html,
                bottomMessageHtml: data.forum_configuration_bottom_message_html,
                apiPath: data.forum_configuration_api_path,
                assistanceTypes: (data?.forum_configuration_assistance_types || '').split(',').map(v => v.trim())
            },
            searchConfiguration: {
                apiPath: data.search_service_api_path,
                abTestingPercentageForSearch: data.search_ab_testing_percentage,
                abTestingPercentageForCategory: data.search_ab_testing_category,
                abTestingPercentageForAllBenefits: data.search_ab_testing_all_benefits,
                abTestingPercentageForAutoComplete: data.autocomplete_ab_testing_percentage,
            },
            facebookLeads: {
                ...parseJson(data.facebookLeads)
            },
            couponsCancellationReasons: data.couponsCancellationReasons,
            newsletter: {
                mobileImage: data.newsletter_popup_mobile_image ?? '',
                image: data.newsletter_popup_image ?? '',
                active: Number(data.newsletter_popup_active ?? true),
                reopenDelayMinutes: data.newsletter_popup_reopen_delay_min ?? 30,
                closeDelaySeconds: data.newsletter_popup_close_delay_sec ??  5,
            },
            consentsConfig: {
                dataSharing: {
                    title: data.translationsArr.consents_datasharing_title,
                    subtitle: data.translationsArr.consents_datasharing_subtitle,
                    description: data.translationsArr.consents_datasharing_description_html,
                    dataSharingCheckbox: data.translationsArr.consents_datasharing_checkbox_html,
                },
                marketing: {
                    title: data.translationsArr.consents_marketing_title,
                    subtitle: data.translationsArr.consents_marketing_subtitle,
                    marketingCheckbox: data.translationsArr.consents_marketing_checkbox_html,
                },
                subsidy: {
                    title: data.translationsArr.consents_subsidy_title,
                    subtitle: data.translationsArr.consents_subsidy_subtitle,
                    subsidyCheckbox: data.translationsArr.consents_subsidy_checkbox_html,
                },
                all: {
                    title: data.translationsArr.consents_all_title,
                    subtitle: data.translationsArr.consents_all_subtitle,
                }
            },
            enable_ma_related_recommendations: data.enable_ma_related_recommendations,
            enable_ma_personal_recommendations: data.enable_ma_personal_recommendations,
            hotyoter: {
                display_hotyoter_panel_main_screen: data.display_hotyoter_panel_main_screen,
            }
        }
        this.updateState(responseData);
    }

    // Dispatch actions to update redux state
    updateState(data) {
        this.dispatch(Actions.setMainMenu(data.MainMenu));
        this.dispatch(Actions.translationsLoaded(data.Translations));
        this.dispatch(Actions.iconTypes(cleanUpObject(data.IconTypes)));
        this.dispatch(Actions.setFooterLinks(data.FooterLinks));
        this.dispatch(Actions.setCitiesArr(data.citiesArr));
        this.dispatch(Actions.setContentUrl(data.ContentUrl));
        this.dispatch(Actions.setAppStoreLink(data.app_store_link));
        this.dispatch(Actions.setCategoriesArr(data.CategoriesArr));
        this.dispatch(Actions.setBenefitTypes(data.BenefitTypes));
        this.dispatch(Actions.set_default_geo(data.DefaultGeo));
        this.dispatch(Actions.setPolicyPageId(data.PolicyPageId));
        this.dispatch(Actions.setPrivacyPage(data.PrivacyPage));
        this.dispatch(Actions.setPopupTranslations(data.PopTrans));
        this.dispatch(Actions.setPolicyUrl(data.PolicyPageId));
        this.dispatch(Actions.setContentWorlds(data.contentWorlds));
        this.dispatch(Actions.setBannerInterval(data.bannerInterval));
        this.dispatch(Actions.setWorkPlaces(data.work_places));
        this.dispatch(Actions.setHotSearches(data.hotSearches));
        this.dispatch(Actions.setBannersArr(data.bannersArr));
        this.dispatch(Actions.setBenefitLogged(data.closedBenefitTypes));
        this.dispatch(Actions.setVerificationCodeMaxAttempsError(data.verificationCodeMaxAttemptsError));
        this.dispatch(Actions.setTutorialDisplayNumber(data.tutorial_display_number));
        this.dispatch(Actions.setSubCategoriesMenu(data.subCategoriesMenu));
        this.dispatch(Actions.setMainCategoriesMenu(data.mainCategoriesMenu));
        this.dispatch(Actions.setOrderStatusArr(data.orderStatusArr));
        this.dispatch(Actions.setSortArr(data.itemsSortTypes));
        this.dispatch(Actions.setTaxPercent(data.taxPercent));
        this.dispatch(Actions.setTradeBenefitsChargeTypes(data.tradeBenefitsChargeTypes));
        this.dispatch(Actions.setBenefitTypesWhatRequireUserValidation(data.benefitTypesWhatRequireUserValidation));
        this.dispatch(Actions.setHomePageBannersInterval(data.home_page_banners_interval));
        this.dispatch(Actions.SetHomePageSliderTypes(data.home_page_slider_types));
        this.dispatch(Actions.SetVehicleAdDisplayTypes(data.vehicle_ad_display_types));
        this.dispatch(Actions.SetTradeBenefitType(data.tradeBenefitType));
        this.dispatch(Actions.setMagazineCategories(data.magazines ?? data.magazineCategories ?? []));
        this.dispatch(Actions.setMegaMenuMaxCategories(data.mega_menu_max_categories));
        this.dispatch(Actions.setMegaMenuMaxSubCategories(data.mega_menu_max_subcategories));
        this.dispatch(Actions.setMegaMenu(data.mega_menu));
        this.dispatch(Actions.setInsuranceData(data.insurance_data));
        this.dispatch(Actions.setDataSharingConfig(data.dataSharingConfig));
        this.dispatch(Actions.setParameter(data.parameters));
        this.dispatch(Actions.setInitialRequestsDone()); // Must be the last update
        this.dispatch(Actions.setNewsletterPopup(data.newsletterPopup));   
        this.dispatch(Actions.setHomepageLogos(data.homepageLogos));

    }

    parseCategories(Obj) {
        let Categories = {Data: Obj, Options: [], SubCategories: {}};

        for (let key in Obj) {
            let item = Obj[key];
            let subCategoriesArr = [];

            Categories.Options.push(
                {id: parseInt(item.id), text: item.name, count: item.totalBenefits, url_name: item.url_name}
            );

            for (let sub_key in item.subCategories) {
                let sub_item = item.subCategories[sub_key];
                subCategoriesArr.push(
                    {
                        id: parseInt(sub_item.id),
                        text: sub_item.name,
                        count: sub_item.totalBenefits,
                        url_name: sub_item.url_name
                    }
                )
            }
            Categories.SubCategories[item.id] = subCategoriesArr;
        }
        return Categories;
    }

    parseContentTable(obj) {
        let table = [];
        for (let key in obj) {
            table.push({id: obj[key], title: key});
        }

        return table;
    }
}

export default GeneralDeclarationRequest;
